import Select from 'react-select'
import { SelectStyles } from '../../../components/Select'
import { useThemeMode } from '../../../_metronic/partials'

interface SelectMultiFilterProps {
  value: string[]
  onChange: (v: string[]) => void
  options: { label: string; value: string }[]
  label?: string
  placeholder?: string
  isSearchable?: boolean
  isClearable?: boolean
  /** Перенос чипов на новые строки вместо прокрутки — для короткого списка, выбранного целиком. */
  wrapChips?: boolean
  /** Выбранные значения пропадают из выпадающего списка — в нём остаётся только то, что ещё можно выбрать. */
  hideSelectedOptions?: boolean
}

/**
 * Themed react-select filter for FilterManager (multi-select).
 *
 * Value is `string[]`. Use the `'selectMulti'` key in `activeFilters`.
 *
 * @example
 * <FilterManager
 *   activeFilters={[{ filter: 'selectMulti', fieldName: 'statuses' }]}
 *   defaultValues={{ statuses: [] }}
 *   filterProps={{ statuses: { label: 'Статусы', options: [...] } }}
 *   onApplyFilters={(f) => console.log(f.statuses)}  // string[]
 * />
 */
export function SelectMultiFilter({
  value,
  onChange,
  options,
  label,
  placeholder = 'Все',
  isSearchable = true,
  isClearable = true,
  wrapChips = false,
  hideSelectedOptions = false,
}: SelectMultiFilterProps) {
  const { mode: theme } = useThemeMode()
  const selected = options.filter((o) => (value ?? []).includes(o.value))

  // Чипы идут одной строкой с горизонтальной прокруткой: перенос растягивал контрол на
  // пол-экрана, а ограничение высоты со скроллом резало чипы пополам. Схлопывать лишние в «+N»
  // тоже нельзя — свёрнутое значение нечем снять, а снимают их по одному.
  // wrapChips — для короткого справочника, где по умолчанию выбрано всё: высота ограничена
  // самим списком, а прокрутка прятала бо́льшую часть выбора.
  const styles = wrapChips ? (SelectStyles(theme) as any) : {
    ...(SelectStyles(theme) as any),
    valueContainer: (base: any) => ({
      ...base,
      flexWrap: 'nowrap',
      overflowX: 'auto',
      overflowY: 'hidden',
      scrollbarWidth: 'thin',
    }),
    multiValue: (base: any) => ({
      ...base,
      flex: '0 0 auto',
    }),
  }

  return (
    <>
      {label && (
        <label className='fs-7 form-label fw-bolder text-dark mb-1'>{label}</label>
      )}
      <Select
        isMulti
        value={selected}
        onChange={(opts) =>
          onChange(((opts as readonly { value: string }[] | null) ?? []).map((o) => o.value))
        }
        options={options}
        placeholder={placeholder}
        isSearchable={isSearchable}
        isClearable={isClearable}
        closeMenuOnSelect={false}
        hideSelectedOptions={hideSelectedOptions}
        styles={styles}
      />
    </>
  )
}
